if (!customElements.get('br-managed-nav')) {
class BrManagedNav extends HTMLElement {
 connectedCallback() {
  if (this.ready) return; this.ready=true;
  this.abort = new AbortController(); const signal=this.abort.signal;
  const close=()=>{this.querySelectorAll('.br-menu-panel').forEach(p=>p.hidden=true);this.querySelectorAll('.br-menu-trigger').forEach(b=>{if(b.tagName==='BUTTON')b.setAttribute('aria-expanded','false')});};
  const activateTab=tab=>{
   const panel=tab.closest('.br-menu-panel');
   if(!panel)return;
   panel.querySelectorAll('[data-br-series]').forEach(p=>p.hidden=p.id!==tab.dataset.brTab);
   panel.querySelectorAll('[data-br-tab]').forEach(b=>b.setAttribute('aria-expanded',String(b.dataset.brTab===tab.dataset.brTab)));
  };
  this.addEventListener('click',e=>{
   const trigger=e.target.closest('button.br-menu-trigger');
   if(trigger){const panel=trigger.nextElementSibling;const opening=panel.hidden;close();panel.hidden=!opening;trigger.setAttribute('aria-expanded',String(opening));if(opening){const finder=panel.querySelector('.br-menu-finder');if(finder)finder.click();}return;}
   if(e.target.closest('[data-br-close]')){const p=e.target.closest('.br-menu-panel');close();p.previousElementSibling.focus();}
   const tab=e.target.closest('[data-br-tab]');if(tab)activateTab(tab);
  },{signal});
  this.addEventListener('pointerover',e=>{const tab=e.target.closest('.br-menu-series [data-br-tab]');if(tab && e.pointerType==='mouse' && tab.getAttribute('aria-expanded')!=='true')activateTab(tab);},{signal});
  document.addEventListener('click',e=>{if(!this.contains(e.target))close();},{signal});
  this.addEventListener('keydown',e=>{if(e.key==='Escape'){const b=this.querySelector('.br-menu-trigger[aria-expanded="true"]');close();b?.focus();}},{signal});
 }
 disconnectedCallback(){this.abort?.abort();this.ready=false;}
}
customElements.define('br-managed-nav',BrManagedNav);
}

if (!customElements.get('br-managed-mobile')) {
  customElements.define('br-managed-mobile', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-br-mobile-target]');
        if (!button) return;
        const target = document.getElementById(button.dataset.brMobileTarget);
        if (!target || !this.contains(target)) return;
        const group = target.closest('.br-mobile-top');
        group.querySelectorAll('.br-mobile-series,.br-mobile-finder').forEach(item => { item.open = item === target; });
        target.open = true;
        target.querySelector('summary').focus();
        target.scrollIntoView({block:'start',behavior:'smooth'});
      }, {signal:this.abort.signal});
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
